import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './home.module.css';
import HomeLegacy from './HomeLegacy';

const isGotoAirport = ['gotoairport.tw', 'www.gotoairport.tw', 'rider.gotoairport.tw'].includes(window.location.hostname);
const showCompanyInfo = ['gotoairport.tw', 'www.gotoairport.tw'].includes(window.location.hostname);

export default function HomeUberTaxi() {
  const brandName = 'Goto Airport';

  useEffect(() => {
    if (!isGotoAirport) return;
    document.title = `${brandName} | 機場接送預約`;
    document.querySelector('meta[name="description"]')?.setAttribute('content', `${brandName} 機場接送預約服務。填寫航班與行程資訊，確認車型及報價。`);
  }, [brandName]);

  if (!isGotoAirport) return <HomeLegacy />;

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <nav className={styles.nav} aria-label="主要導覽">
          <Link className={styles.brand} to="/" aria-label={`${brandName} 首頁`}>
            {brandName}
          </Link>
          <div className={styles.navLinks}>
            <a href="#services">服務特色</a>
            <a href="#steps">預約流程</a>
            <Link className={styles.navCta} to="/rider/order/create">立即預約</Link>
          </div>
        </nav>
      </header>
      <main>
        <section className={styles.hero} aria-labelledby="hero-title">
          <div className={styles.heroInner}>
            <div className={styles.heroCopy}>
              <p className={styles.eyebrow}>AIRPORT TRANSFER · TAIWAN</p>
              <h1 id="hero-title">台灣機場接送，<br />安心直達目的地。</h1>
              <p>從航班資訊到車型需求，在同一個預約流程中完成。</p>
            </div>
            <div className={styles.bookingCard}>
              <span className={styles.cardLabel}>開始規劃行程</span>
              <h2>預約您的機場接送</h2>
              <p>先填寫航班、接送地點及搭乘需求，再確認報價。</p>
              <Link className={styles.primaryButton} to="/rider/order/create">開始查價與預約 <span aria-hidden="true">→</span></Link>
              <small>進入預約流程前可能需要登入。</small>
            </div>
          </div>
        </section>
        <section className={styles.section} id="services" aria-labelledby="services-title">
          <div className={styles.container}>
            <p className={styles.eyebrow}>WHY RIDE WITH US</p>
            <h2 id="services-title">行程需求，一步步確認</h2>
            <div className={styles.featureGrid}>
              <article className={styles.feature}><span aria-hidden="true">01</span><h3>航班資訊</h3><p>預約時填寫航班資訊，方便確認接機或送機行程。</p></article>
              <article className={styles.feature}><span aria-hidden="true">02</span><h3>接送地點</h3><p>選擇機場與上下車地點，建立清楚的接送路線。</p></article>
              <article className={styles.feature}><span aria-hidden="true">03</span><h3>乘車需求</h3><p>依人數與行李需求選擇適合的可用車型。</p></article>
            </div>
          </div>
        </section>
        <section className={`${styles.section} ${styles.soft}`} id="steps" aria-labelledby="steps-title">
          <div className={styles.container}>
            <p className={styles.eyebrow}>HOW IT WORKS</p>
            <h2 id="steps-title">三步完成預約</h2>
            <ol className={styles.steps}>
              <li><strong>填寫行程</strong><span>提供航班與接送地址。</span></li>
              <li><strong>確認需求</strong><span>選擇車型、行李數量並查看報價。</span></li>
              <li><strong>完成預約</strong><span>確認旅客資訊及訂單。</span></li>
            </ol>
          </div>
        </section>
        <section className={styles.finalCta} aria-labelledby="final-title">
          <div className={styles.container}>
            <h2 id="final-title">準備好出發了嗎？</h2>
            <p>從您的航班與接送地點開始。</p>
            <Link className={styles.primaryButton} to="/rider/order/create">開始預約 <span aria-hidden="true">→</span></Link>
          </div>
        </section>
      </main>
      <footer className={styles.footer}>
        <div className={styles.container}>
          <strong>{brandName}</strong>
          <div className={styles.footerLinks}>
            <Link to="/privacy-policy">隱私政策</Link>
          </div>
          {showCompanyInfo && (
            <div className={styles.companyInfo}>
              <span>好朋友小客車租賃有限公司</span>
              <span>統一編號：66367788</span>
              <a href="mailto:gf66367788@gmail.com">gf66367788@gmail.com</a>
            </div>
          )}
          <small>© {new Date().getFullYear()} {brandName}</small>
        </div>
      </footer>
    </div>
  );
}
